import Constants from '../common/Constants';
import languages from "../languages";


export default {
  isLoading : true,
  timeStamp: null,
  modalOpen: null,
  debug: false,
  wid: null,
  t: languages[Constants.DEFAULT_LANGUAGE],
  widgetStatus: 0,
  widgetWebsite: '',
  isLoaded: false,
  baseURL: Constants.BASE_URL,
  embedURL: Constants.EMBED_URL,
  widgetOptions: {
    removeBranding: '0',
    enableContactAddress: '0',
    contactAddress: '',
    enableCustomLogo: '0',
    customLogo: '',
    enableCustomLogoUrl: "0",
    customLogoUrl: "#",
    soundEffect: '0',
    statementLink: '',
    statementSource: 'url',
    statementLinkText: 'Accessibility statement',
    statementText: '',
    showStatement: '0',
    customTrigger: '0',
    customTriggerId: '',
    brandDomain: 'https://adabundle.com',
    brandSlogan: 'Powered By AdaBundle',
    onlineDictionary: "1",
    language: "auto",
    profileEpilepsy: "0",
    profileVisuallyImpaired: "0",
    profileCognitiveDisability: "0",
    profileAdhdFriendly: "0",
    profileBlindUsers: "0",
    contentScaling: "1",
    readableFont: "1",
    dyslexiaFont: "1",
    highlightTitles: "1",
    highlightLinks: "1",
    textMagnifier: "1",
    fontSizing: "1",
    lineHeight: "1",
    letterSpacing: "1",
    alignCenter: "1",
    alignLeft: "1",
    alignRight: "1",
    darkContrast: "1",
    lightContrast: "1",
    monochrome: "1",
    highSaturation: "1",
    highContrast: "1",
    lowSaturation: "1",
    textColors: "0",
    titleColors: "0",
    backgroundColors: "0",
    muteSounds: "1",
    hideImages: "1",
    virtualKeyboard: "1",
    readingGuide: "1",
    usefulLinks: "1",
    stopAnimations: "1",
    readingMask: "1",
    highlightHover: "1",
    highlightFocus: "1",
    bigBlackCursor: "1",
    bigWhiteCursor: "1",
    textToSpeech: "1",
    keyboardNavigation: "1",
    showOpenButton: "1",
    buttonPosition: " bottom-left",
    buttonCaption: "",
    buttonIcon: "",
    buttonIconPosition: "before",
    buttonSize: "40",
    buttonMargin: "12",
    buttonPadding: "5",
    buttonBorderRadius: "50",
    buttonColor: "rgba(255, 255, 255, 1)",
    buttonColorHover: "rgba(255, 255, 255, 1)",
    buttonBgcolor: "rgba(31, 88, 230, 1)",
    buttonBgcolorHover: "rgba(31, 88, 230, 1)",
    buttonEntranceTimeout: "0",
    buttonEntranceAnimation: "wobble",
    buttonHoverAnimation: "none",
    popupOverlayColor: "#0253ee",
    popupBackgroundColor: "#ffffff",
    popupKeyColor: "rgba(33, 150, 243, 1)",
    popupBorderRadius: "20",
    popupAnimation: "fade",
    popupScroll: "",
    hotKeyOpenInterface: "Alt+9",
    LEARN_MORE_IN_WIKIPEDIA: "Learn more in Wikipedia",
    DEFAULT: "Default",
    HOME: "Home",
    HIDE_ACCESSIBILITY_INTERFACE: "Hide Accessibility Interface? \n\nPlease note: If you choose to hide the accessibility interface, you won't be able to see it anymore, unless you clear clear cookies for this site. Are you sure that you wish to hide the interface?",
    highlightTitlesStyle: "solid",
    highlightTitlesColor: "#639af9",
    highlightTitlesWidth: "2",
    highlightTitlesOffset: "2",
    highlightLinksStyle: "solid",
    highlightLinksColor: "#f96363",
    highlightLinksWidth: "2",
    highlightLinksOffset: "2",
    textMagnifierBgColor: "#333333",
    textMagnifierColor: "#ffffff",
    textMagnifierFontSize: "36",
    readingGuideWidth: "500",
    readingGuideHeight: "10",
    readingGuideBackgroundColor: "#174cd6",
    readingGuideBorderColor: "#000000",
    readingGuideBorderWidth: "2",
    readingGuideBorderRadius: "10",
    readingMaskHeight: "100",
    readingMaskColor: "rgba(0, 0, 0, 0.7)",
    highlightHoverStyle: "solid",
    highlightHoverColor: "#639af9",
    highlightHoverWidth: "2",
    highlightHoverOffset: "2",
    highlightFocusStyle: "solid",
    highlightFocusColor: "#639af9",
    highlightFocusWidth: "2",
    highlightFocusOffset: "2",
    virtualKeyboardLayout: "english",
    hotKeyMenu: "M",
    hotKeyHeadings: "H",
    hotKeyForms: "F",
    hotKeyButtons: "B",
    hotKeyGraphics: "G"
  }
};


